module.exports = __webpack_public_path__ + "img/img-6.e2df946b.png";